'use strict';

exports.__esModule = true;

var _react = require('react');

exports["default"] = _react.PropTypes.shape({
  subscribe: _react.PropTypes.func.isRequired,
  dispatch: _react.PropTypes.func.isRequired,
  getState: _react.PropTypes.func.isRequired
});


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-redux/lib/utils/storeShape.js
 ** module id = 721
 ** module chunks = 0
 **/